import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './Spinner.module.css';

export type SpinnerProps = PropsWithoutChildren<ComponentProps<'div'>>;

export const Spinner: FunctionComponent<SpinnerProps> = React.memo((props) => {
  const { className, ...remainingProps } = prepareProps({
    props,
    ignoreChildren: true
  });

  return (
    <div
      {...remainingProps}
      className={classes(className, styles.container)}
    >
      <svg
        className={styles.svg}
        viewBox="25 25 50 50"
      >
        <circle
          className={styles.circle}
          cx="50"
          cy="50"
          r="20"
          vectorEffect="non-scaling-stroke"
        ></circle>
      </svg>
    </div>
  );
});
